// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#search .search-text-initial[data-v-233f7294]{background-color:var(--body-bg)}#search .search-content[data-v-233f7294]{min-height:500px}#search .search-content .sort-order[data-v-233f7294]{float:right;height:2em;line-height:1;margin-left:15px;padding:0 30px 0 15px;width:auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
